/** Date calendaire "YYYY-MM-DD" d'un instant dans un fuseau donné (ex. Europe/Paris). */
export function localDate(instant: Date | string, timeZone: string): string {
  const date = typeof instant === 'string' ? new Date(instant) : instant;
  // en-CA formate en AAAA-MM-JJ.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

/** Écart en jours entiers entre deux dates "YYYY-MM-DD". */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);
}

/** Instant (UTC ISO) de la fin d'une journée locale, approximée à 23:59:59 dans le fuseau. */
export function endOfLocalDay(date: string, timeZone: string): string {
  // Décalage du fuseau à midi ce jour-là (évite les ambiguïtés de changement d'heure à minuit).
  const noonUtc = new Date(`${date}T12:00:00Z`);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(noonUtc);
  const localHour = Number(parts.find((p) => p.type === 'hour')?.value ?? '12');
  const offsetHours = localHour - 12;
  return new Date(Date.parse(`${date}T23:59:59Z`) - offsetHours * 3_600_000).toISOString();
}

/** Heure locale (0–23) d'un instant dans un fuseau donné. */
export function localHour(instant: Date | string, timeZone: string): number {
  const date = typeof instant === 'string' ? new Date(instant) : instant;
  const parts = new Intl.DateTimeFormat('en-US', { timeZone, hour: '2-digit', hourCycle: 'h23' }).formatToParts(date);
  return Number(parts.find((p) => p.type === 'hour')?.value ?? '0');
}
